import { createContext, useContext } from "react";
import { OmsProduct } from "../lusca-search-api/generated-src";

export type OmsContextIdentity = {
  namespace: string;
  financialAccount?: string;
};

export const OmsContextIdentityContext = createContext<
  OmsContextIdentity | undefined
>(undefined);

export function useOmsIdentity(product: OmsProduct): OmsContextIdentity {
  return useContext(OmsContextIdentityContext) || { namespace: product };
}

export function omsContextPath(product: string, account?: string) {
  return `/dashboard/oms/${product}${account ? `/account/${account}` : ""}`;
}
